// extracted by mini-css-extract-plugin
export var actionText = "_ld-4";
export var container = "_ld-0";
export var leftSection = "_ld-1";
export var rightSection = "_ld-2";
export var settingsButton = "_ld-6";
export var settingsIcon = "_ld-7";
export var shortcut = "_ld-5";
export var shortcutGroup = "_ld-3";